export var FilterOptionsError;
(function (FilterOptionsError) {
})(FilterOptionsError || (FilterOptionsError = {}));
var FilterOptionsRequest = /** @class */ (function () {
    function FilterOptionsRequest() {
        this.knownErrorCodes = Object.values(FilterOptionsError);
        this.path = 'info-cards/filter-options';
    }
    return FilterOptionsRequest;
}());
export { FilterOptionsRequest };
